import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import BusinessIcon from "@mui/icons-material/Business";
import PeopleIcon from "@mui/icons-material/People";
import PersonIcon from "@mui/icons-material/Person";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentIcon from "@mui/icons-material/Assignment";
import EmailIcon from "@mui/icons-material/Email";
import FunctionsIcon from "@mui/icons-material/Functions";
import FolderIcon from "@mui/icons-material/Folder";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import DeleteIcon from "@mui/icons-material/Delete";
import InsightsIcon from "@mui/icons-material/Insights";

/** Super admin panel navigasyon yapılandırması */
export function getSuperAdminNavSections() {
  return [
    {
      id: "overview",
      label: "Overview",
      items: [
        {
          id: "dashboard",
          label: "Dashboard",
          path: "/super-admin/dashboard",
          Icon: DashboardOutlinedIcon,
        },
        {
          id: "plans",
          label: "Plans & add-ons",
          path: "/super-admin/plans",
          Icon: WorkspacePremiumIcon,
        },
      ],
    },
    {
      id: "platform",
      label: "Platform",
      items: [
        {
          id: "tenants",
          label: "Tenants",
          path: "/super-admin/tenants",
          Icon: BusinessIcon,
        },
        {
          id: "doctors",
          label: "Doctors",
          path: "/super-admin/doctors",
          Icon: PeopleIcon,
        },
        {
          id: "patients",
          label: "Patients",
          path: "/super-admin/patients",
          Icon: PersonIcon,
        },
      ],
    },
    {
      id: "content",
      label: "Content",
      items: [
        {
          id: "form-market",
          label: "Form Market",
          path: "/super-admin/form-market",
          Icon: DescriptionIcon,
        },
        {
          id: "forms",
          label: "Forms",
          path: "/super-admin/forms",
          Icon: DescriptionIcon,
        },
        {
          id: "form-answers",
          label: "Form Answers",
          path: "/super-admin/form-answers",
          Icon: AssignmentIcon,
        },
        {
          id: "form-invitations",
          label: "Form Invitations",
          path: "/super-admin/form-invitations",
          Icon: EmailIcon,
        },
        {
          id: "scoring-formulas",
          label: "Scoring Formulas",
          path: "/super-admin/scoring-formulas",
          Icon: FunctionsIcon,
        },
        {
          id: "files",
          label: "Files",
          path: "/super-admin/files",
          Icon: FolderIcon,
        },
      ],
    },
    {
      id: "operations",
      label: "Operations",
      items: [
        {
          id: "doctor-invitations",
          label: "Doctor Invitations",
          path: "/super-admin/doctor-invitations",
          Icon: EmailIcon,
        },
        {
          id: "password-resets",
          label: "Password Resets",
          path: "/super-admin/password-resets",
          Icon: VpnKeyIcon,
        },
        {
          id: "trash-logs",
          label: "Trash Logs",
          path: "/super-admin/trash-logs",
          Icon: DeleteIcon,
        },
        {
          id: "monitoring",
          label: "Log & Monitoring",
          path: "/super-admin/monitoring",
          Icon: InsightsIcon,
        },
      ],
    },
  ];
}

export const SUPER_ADMIN_NAV_OPTIONS = {
  matchSubpaths: true,
};
